import request from '@/utils/request';

const PATH = '/reservation-category';

export const getReservationCategoryList = (typeUid: string) => request({
  url: `${PATH}/${typeUid}/list`,
  method: 'get',
});

export const getReservationCategoryPage = (params: any) => request({
  url: `${PATH}/list`,
  method: 'get',
  params: {
    ...params,
    page: params.page - 1,
  },
});

export const getReservationCategory = (uid: string) => request({
  url: `${PATH}/${uid}`,
  method: 'get',
});

export const addReservationCategory = (data: any) => request({
  url: PATH,
  method: 'post',
  data,
});

export const updateReservationCategory = (uid: string, data: any) => request({
  url: `${PATH}/${uid}`,
  method: 'put',
  data,
});

export const deleteReservationCategory = (uid: string) => request({
  url: `${PATH}/${uid}`,
  method: 'delete',
});
